(function () {
  'use strict';

  var STORAGE_KEY = 'vatpan_visitor_country';
  var GEO_ATTR = 'data-vatpan-geo';

  function setGeo(mode) {
    if (mode !== 'tr' && mode !== 'intl') return;
    document.documentElement.setAttribute(GEO_ATTR, mode);
    try {
      sessionStorage.setItem(STORAGE_KEY, mode === 'tr' ? 'TR' : 'INTL');
    } catch (e) {
      // ignore
    }
    document.dispatchEvent(
      new CustomEvent('vatpan:geo', { detail: { mode: mode } })
    );
  }

  function modeFromCountry(code) {
    return String(code || '')
      .trim()
      .toUpperCase() === 'TR'
      ? 'tr'
      : 'intl';
  }

  function readCachedMode() {
    try {
      var cached = sessionStorage.getItem(STORAGE_KEY);
      if (cached === 'TR') return 'tr';
      if (cached === 'INTL') return 'intl';
    } catch (e) {
      // ignore
    }
    return null;
  }

  function parseCountryIs(payload) {
    if (!payload || !payload.country) return null;
    return payload.country;
  }

  function detectCountry() {
    return fetch('https://api.country.is/', {
      credentials: 'omit',
      cache: 'no-store',
    })
      .then(function (res) {
        if (!res.ok) throw new Error('country.is failed');
        return res.json();
      })
      .then(parseCountryIs)
      .catch(function () {
        return fetch('https://ipapi.co/country_code/', {
          credentials: 'omit',
          cache: 'no-store',
        }).then(function (res) {
          if (!res.ok) throw new Error('ipapi failed');
          return res.text();
        });
      });
  }

  var cached = readCachedMode();
  if (cached) {
    setGeo(cached);
    return;
  }

  detectCountry()
    .then(function (country) {
      setGeo(modeFromCountry(country));
    })
    .catch(function () {
      // Fail open as international so Markets-missing countries still get quote CTAs
      setGeo('intl');
    });
})();
